import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../tools/store";

const initialState: {
  theme: "light" | "dark" | string;
  language: string;
  font_size: number;
  bookmarkList: any;
  notesList: any;
  isArabic: boolean;
} = {
  theme: "dark",
  language: "en",
  font_size: 28,
  bookmarkList: [],
  notesList: [],
  isArabic: false,
};
export const GlobalReducerName = "global";

export const GlobalSlice = createSlice({
  name: GlobalReducerName,
  initialState,
  reducers: {
    toggleTheme(state, action: PayloadAction<string>) {
      // state.theme = action.payload == "dark" ? "light" : "dark";
      state.theme = action.payload;
    },
    setFontSize: (state, action: PayloadAction<number>) => {
      state.font_size = action.payload;
    },
    setCurrnetLanguage: (state, action) => {
      state.language = action.payload;
      state.isArabic = action.payload === "ar";
    },

    setBookmarkList: (state, action) => {
      state.bookmarkList = action.payload;
    },
    setNotesList: (state, action) => {
      state.notesList = action.payload;
    },
  },
});

export const {
  toggleTheme,
  setFontSize,
  setCurrnetLanguage,
  setBookmarkList,
  setNotesList,
} = GlobalSlice.actions;

export const getTheme = (state: RootState) => state.global.theme;
export const getFontSize = (state: RootState) => state.global.font_size;

export const getCurrentlanguage = (state: RootState) => state.global.language;

export const getBookmarkList = (state: RootState) => state.global.bookmarkList;

export const getNotesList = (state: RootState) => state.global.notesList;

export const getIsArabic = (state: RootState) => state.global.isArabic;

export default GlobalSlice.reducer;
